<template>
  <div class="token-icon-content">
    <!-- <img
      class="token-icon"
      :src="tokenIcon"
      alt=""
      onerror="javascript:this.src='https://tokenpocket.cdn.bcebos.com/common.png';"
    /> -->
    <div class="token-icon">
      <TransitSymbolIcon :icon="tokenIcon" :symbol="symbol" />
    </div>
    <img v-if="networkIcon" class="network-icon" :src="networkIcon" alt="" />
    <!-- crossorigin="anonymous" -->
  </div>
</template>

<script>
import TransitSymbolIcon from "./TransitSymbolIcon.vue";
export default {
  props: {
    tokenIcon: {
      type: String
    },
    networkIcon: {
      type: String
    },
    symbol: {
      type: String,
      required: true
    }
  },
  components: {
    TransitSymbolIcon
  },
};
</script>

<style lang="less" scoped>
.token-icon-content {
  position: relative;
  width: 36px;
  height: 36px;
  .token-icon {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 1px solid var(--token-icon-border-1);
    box-sizing: border-box;
  }
  .network-icon {
    position: absolute;
    right: -4px;
    bottom: -0;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid var(--network-icon-border-1);
    background: #fff;
  }
}

@media screen and (max-width: 680px) {
  .token-icon-content {
    width: 42px;
    height: 42px;
  }
  
}
</style>
